<script lang='ts'>
import { onMount } from 'svelte';
import { pevent } from '../../analytics';
import { getBadges,getPassportLeaderboard,getPassportRank,getPassportUnread,isBadgeDone,type Badge,type Rank,type UnreadEntry } from '../../services';
import { liveChannel,user } from '../../store';
import { wait } from '../../util';
import BadgeNotification from '../BadgeNotification.svelte';
import Badges from '../Badges.svelte';

export let sectionTitle;
export let title;
export let subtitle;
export let header;

let activeBadge: Badge;
let badges = [];
let queue = [];
let rank: Rank = {
  name: '',
  points: 0,
  rank: -1
};
let leaderboard = [];
let error;
let liveSub;

let leaderboardStartIndex = 0;
let leaderboardEndIndex = 4;
let leaderboardLessPages = false;
let leaderboardMorePages = true;
let leaderboardWidth = 0;
let leaderboardCount = -1;
let priorLeaderboardRequest = { start: -1, end: -1 }

function onPage(next: boolean) {
  leaderboardStartIndex += next ? leaderboardCount : -leaderboardCount;
  
  if (leaderboardStartIndex < 0) {
    leaderboardStartIndex = 0;
  }
  
  // Triggers reaction
}

function nextBadge() {
  const b = queue.pop();
  activeBadge = b ? {
    ...b,
    done: isBadgeDone(b)
  } : undefined;
}

async function getLeaderboardPage(start, end) {
  const span = end - start + 1;

  if (start < 0 || span <= 0 || (
    priorLeaderboardRequest.start === start && priorLeaderboardRequest.end === end
  )) return;
  leaderboard = await getPassportLeaderboard(start, end);

  leaderboardMorePages = leaderboard.length >= span;
  leaderboardLessPages = start > 0;

  leaderboardStartIndex = start;
  leaderboardEndIndex = end;
  priorLeaderboardRequest = { start, end }
}

async function refreshLeaderboard() {
  leaderboard = await getPassportLeaderboard(leaderboardStartIndex, leaderboardEndIndex);
}

async function load() {
  let unread: UnreadEntry[];
  ([badges, rank, unread] = await Promise.all([
    getBadges(),
    getPassportRank(),
    getPassportUnread()
  ]));

  rank = {
    ...rank,
    name: $user.name
  }

  $user.rank = rank.rank;

  // TODO cleanup livechannel subscription
  liveSub = liveChannel.subscribe('user_' + $user.id, $user.token, msg => {
    if (msg.event === 'badge_progress') {
      // Update progress on badge
      msg.badges.forEach(badge => {
        const b = badges.find(b => b.id === badge.id);
        if (b) {
          b.progress = badge.progress;
        }
      });
      badges = badges;

      // Append to queue
      const uread = unread.map(e => badges.find(b => b.id === e.badgeId)).filter(x => x);
      queue = [...queue, ...uread, ...msg.badges.map(bdg => badges.find(b => b.id === bdg.id)).filter(x => x)];
      unread = []
      rank = {
        name: $user.name,
        points: msg.points,
        rank: msg.rank
      }

      console.log("Badges", badges, "Queue", queue)

      if (!activeBadge) nextBadge();

      getPassportUnread();  // call unread to mark as read
      refreshLeaderboard();
    }
  });

  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  if (code) {
    // Update URL to remove query param without refresh
    window.history.replaceState('', '', window.location.pathname);

    // Wait for live connection
    for (let i = 0; i < 20; i++) {
      await wait(500);
      if (liveChannel.isConnected()) {
        try {
          pevent('qr', 'view', code, 1, '', false);
        } catch (e) {
          console.error("Error sending scan", e)
        }
        break;
      }
    }
  } else {
    // If not code, queue unread, otherwise, queue unread in live listener
    queue = unread.map(e => badges.find(b => b.id === e.badgeId)).filter(x => x);
    nextBadge();
    unread = []
  }
}

onMount(() => {
  load()
  return () => liveSub?.();
});

$: leaderboardCount = Math.max(0, Math.min(10, Math.floor((leaderboardWidth - (58*2)) / 150)));
$: getLeaderboardPage(leaderboardStartIndex, leaderboardStartIndex + leaderboardCount - 1);
</script>

<Badges bind:leaderboardWidth {badges} {rank} {leaderboard} {sectionTitle} {header} {title} {subtitle} {leaderboardLessPages} {leaderboardMorePages} {onPage} />
{#if activeBadge}
  <BadgeNotification badge={activeBadge} on:click={nextBadge} />
{/if}